var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92 7.68a2.773 2.773 0 1 0 0-5.547 2.773 2.773 0 0 0 0 5.547zM8 9.067c.002-.232.062-.46.175-.661-.104-.011-.205-.033-.314-.033H7.5a3.772 3.772 0 0 1-3.159 0H3.98a2.913 2.913 0 0 0-2.912 2.912v.902a1.04 1.04 0 0 0 1.04 1.04h6.086A1.377 1.377 0 0 1 8 12.533V9.067zm6.24-.694h-.693V6.64a1.734 1.734 0 0 0-3.467 0v1.733h-.693a.693.693 0 0 0-.694.694v3.466a.694.694 0 0 0 .694.694h4.853a.693.693 0 0 0 .693-.694V9.067a.693.693 0 0 0-.693-.694zm-1.733 0H11.12V6.64a.693.693 0 1 1 1.387 0v1.733z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLock);
export default __webpack_public_path__ + "static/media/UserLock.69d6af41.svg";
export { ForwardRef as ReactComponent };